import { render, staticRenderFns } from "./BKCrewChip.vue?vue&type=template&id=b79b6e0e&scoped=true"
import script from "./BKCrewChip.vue?vue&type=script&lang=js"
export * from "./BKCrewChip.vue?vue&type=script&lang=js"
import style0 from "./BKCrewChip.vue?vue&type=style&index=0&id=b79b6e0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79b6e0e",
  null
  
)

export default component.exports